export const medications = [
  {
    id: 1,
    name: 'Metformin 500mg',
    brandName: 'Glucophage',
    price: 12.99,
    pbsPrice: 6.80,
    category: 'Diabetes',
    inStock: true,
    stockLevel: 45,
    prescription: true,
    description: 'Oral medication used to treat type 2 diabetes by improving blood sugar control',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Low risk',
    dosage: '1 tablet twice daily with meals',
    sideEffects: 'Nausea, diarrhea, stomach upset',
    interactions: 'May interact with certain heart medications and contrast dyes',
    image: 'https://placehold.co/100x100/e0f2fe/3b82f6?text=Met',
    rating: 4.5,
    reviews: 128,
    mrp: {
      preferredSupplier: 'SYM',
      avgWeeklyDemand: 15,
      minStock: 10,
      maxStock: 50,
      safetyStock: 7,
      reorderPoint: 12,
      leadTimeDays: 1,
      movementCategory: 'PBS Fast Mover',
      lastOrdered: '2026-02-12',
      lastReceived: '2026-02-13',
    },
    stockByLocation: { LOC001: 45, LOC002: 30, LOC003: 22, LOC004: 15 },
  },
  {
    id: 2,
    name: 'Lisinopril 10mg',
    brandName: 'Zestril',
    price: 8.50,
    pbsPrice: 6.80,
    category: 'Blood Pressure',
    inStock: true,
    stockLevel: 12,
    prescription: true,
    description: 'ACE inhibitor medication used to treat high blood pressure and heart failure',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Medium risk',
    dosage: '1 tablet daily',
    sideEffects: 'Dry cough, dizziness, headache',
    interactions: 'May interact with potassium supplements and NSAIDs',
    image: 'https://placehold.co/100x100/e0f2fe/3b82f6?text=Lis',
    rating: 4.3,
    reviews: 87,
    mrp: {
      preferredSupplier: 'SYM',
      avgWeeklyDemand: 8,
      minStock: 6,
      maxStock: 25,
      safetyStock: 4,
      reorderPoint: 8,
      leadTimeDays: 1,
      movementCategory: 'PBS Medium Mover',
      lastOrdered: '2026-02-10',
      lastReceived: '2026-02-11',
    },
    stockByLocation: { LOC001: 12, LOC002: 18, LOC003: 8, LOC004: 6 },
  },
  {
    id: 3,
    name: 'Ibuprofen 200mg',
    brandName: 'Nurofen',
    price: 6.99,
    pbsPrice: null,
    category: 'Pain Relief',
    inStock: true,
    stockLevel: 89,
    prescription: false,
    description: 'Non-steroidal anti-inflammatory drug (NSAID) for pain relief and reducing inflammation',
    tgaApproved: true,
    pbs: false,
    safetyLevel: 'Low risk',
    dosage: '1-2 tablets every 4-6 hours as needed',
    sideEffects: 'Stomach upset, heartburn, dizziness',
    interactions: 'May interact with blood thinners and certain blood pressure medications',
    image: 'https://placehold.co/100x100/e0f2fe/3b82f6?text=Ibu',
    rating: 4.7,
    reviews: 234,
    mrp: {
      preferredSupplier: 'API',
      avgWeeklyDemand: 30,
      minStock: 30,
      maxStock: 120,
      safetyStock: 15,
      reorderPoint: 35,
      leadTimeDays: 1,
      movementCategory: 'OTC Fast Mover',
      lastOrdered: '2026-02-14',
      lastReceived: '2026-02-15',
    },
    stockByLocation: { LOC001: 89, LOC002: 65, LOC003: 72, LOC004: 40 },
  },
  {
    id: 4,
    name: 'Atorvastatin 20mg',
    brandName: 'Lipitor',
    price: 15.75,
    pbsPrice: 6.80,
    category: 'Cholesterol',
    inStock: false,
    stockLevel: 0,
    prescription: true,
    description: 'Statin medication used to lower blood cholesterol levels and reduce risk of heart disease',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Medium risk',
    estimatedRestock: '2026-02-17',
    dosage: '1 tablet daily in the evening',
    sideEffects: 'Muscle pain, weakness, liver problems',
    interactions: 'May interact with grapefruit juice and certain antibiotics',
    image: 'https://placehold.co/100x100/e0f2fe/3b82f6?text=Ato',
    rating: 4.4,
    reviews: 156,
    mrp: {
      preferredSupplier: 'SYM',
      avgWeeklyDemand: 25,
      minStock: 18,
      maxStock: 60,
      safetyStock: 11,
      reorderPoint: 15,
      leadTimeDays: 1,
      movementCategory: 'PBS Fast Mover',
      lastOrdered: '2026-02-14',
      lastReceived: null,
      backOrdered: true,
    },
    stockByLocation: { LOC001: 0, LOC002: 5, LOC003: 3, LOC004: 0 },
  },
  {
    id: 5,
    name: 'Sertraline 50mg',
    brandName: 'Zoloft',
    price: 9.99,
    pbsPrice: 6.80,
    category: 'Mental Health',
    inStock: true,
    stockLevel: 32,
    prescription: true,
    description: 'Selective serotonin reuptake inhibitor (SSRI) used to treat depression and anxiety disorders',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Medium risk',
    dosage: '1 tablet daily with food',
    sideEffects: 'Nausea, insomnia, dizziness',
    interactions: 'May interact with MAOIs and certain pain medications',
    image: 'https://placehold.co/100x100/e0f2fe/3b82f6?text=Ser',
    rating: 4.2,
    reviews: 98,
    mrp: {
      preferredSupplier: 'SYM',
      avgWeeklyDemand: 14,
      minStock: 10,
      maxStock: 40,
      safetyStock: 6,
      reorderPoint: 12,
      leadTimeDays: 1,
      movementCategory: 'PBS Fast Mover',
      lastOrdered: '2026-02-11',
      lastReceived: '2026-02-12',
    },
    stockByLocation: { LOC001: 32, LOC002: 20, LOC003: 15, LOC004: 10 },
  },
  {
    id: 6,
    name: 'Ventolin Inhaler 100mcg',
    brandName: 'Salbutamol',
    price: 14.50,
    pbsPrice: 6.80,
    category: 'Respiratory',
    inStock: true,
    stockLevel: 25,
    prescription: false,
    description: 'Bronchodilator used to relieve symptoms of asthma and COPD',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Low risk',
    dosage: '1-2 puffs every 4-6 hours as needed',
    sideEffects: 'Tremor, increased heart rate, headache',
    interactions: 'May interact with certain blood pressure medications',
    image: 'https://placehold.co/100x100/e0f2fe/3b82f6?text=Ven',
    rating: 4.8,
    reviews: 312,
    mrp: {
      preferredSupplier: 'API',
      avgWeeklyDemand: 12,
      minStock: 8,
      maxStock: 30,
      safetyStock: 5,
      reorderPoint: 10,
      leadTimeDays: 1,
      movementCategory: 'PBS Medium Mover',
      lastOrdered: '2026-02-10',
      lastReceived: '2026-02-11',
    },
    stockByLocation: { LOC001: 25, LOC002: 15, LOC003: 20, LOC004: 8 },
  },
  {
    id: 7,
    name: 'Paracetamol 500mg',
    brandName: 'Panadol',
    price: 5.49,
    pbsPrice: null,
    category: 'Pain Relief',
    inStock: true,
    stockLevel: 150,
    prescription: false,
    description: 'Common analgesic for pain relief and fever reduction',
    tgaApproved: true,
    pbs: false,
    safetyLevel: 'Low risk',
    dosage: '1-2 tablets every 4-6 hours, max 8 per day',
    sideEffects: 'Rare at normal doses; liver damage at high doses',
    interactions: 'May interact with warfarin and alcohol',
    image: 'https://placehold.co/100x100/e0f2fe/3b82f6?text=Par',
    rating: 4.8,
    reviews: 456,
    mrp: {
      preferredSupplier: 'API',
      avgWeeklyDemand: 40,
      minStock: 40,
      maxStock: 200,
      safetyStock: 20,
      reorderPoint: 50,
      leadTimeDays: 1,
      movementCategory: 'OTC Fast Mover',
      lastOrdered: '2026-02-14',
      lastReceived: '2026-02-15',
    },
    stockByLocation: { LOC001: 150, LOC002: 100, LOC003: 120, LOC004: 60 },
  },
  {
    id: 8,
    name: 'Amoxicillin 500mg',
    brandName: 'Amoxil',
    price: 11.99,
    pbsPrice: 6.80,
    category: 'Antibiotics',
    inStock: true,
    stockLevel: 60,
    prescription: true,
    description: 'Penicillin-type antibiotic used to treat bacterial infections',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Low risk',
    dosage: '1 capsule three times daily for 7 days',
    sideEffects: 'Diarrhea, nausea, skin rash',
    interactions: 'May reduce effectiveness of oral contraceptives',
    image: 'https://placehold.co/100x100/fef3c7/f59e0b?text=Amx',
    rating: 4.4,
    reviews: 189,
    mrp: {
      preferredSupplier: 'CH2',
      avgWeeklyDemand: 10,
      minStock: 7,
      maxStock: 30,
      safetyStock: 4,
      reorderPoint: 9,
      leadTimeDays: 1,
      movementCategory: 'PBS Medium Mover',
      lastOrdered: '2026-02-12',
      lastReceived: '2026-02-13',
    },
    stockByLocation: { LOC001: 60, LOC002: 35, LOC003: 40, LOC004: 20 },
  },
  {
    id: 9,
    name: 'Cetirizine 10mg',
    brandName: 'Zyrtec',
    price: 8.99,
    pbsPrice: null,
    category: 'Allergies',
    inStock: true,
    stockLevel: 78,
    prescription: false,
    description: 'Antihistamine for relief of hay fever and allergy symptoms',
    tgaApproved: true,
    pbs: false,
    safetyLevel: 'Low risk',
    dosage: '1 tablet daily',
    sideEffects: 'Drowsiness, dry mouth, fatigue',
    interactions: 'May enhance effects of alcohol and sedatives',
    image: 'https://placehold.co/100x100/ddd6fe/8b5cf6?text=Cet',
    rating: 4.6,
    reviews: 267,
    mrp: {
      preferredSupplier: 'API',
      avgWeeklyDemand: 18,
      minStock: 15,
      maxStock: 90,
      safetyStock: 8,
      reorderPoint: 20,
      leadTimeDays: 1,
      movementCategory: 'OTC Medium Mover',
      lastOrdered: '2026-02-10',
      lastReceived: '2026-02-11',
    },
    stockByLocation: { LOC001: 78, LOC002: 50, LOC003: 60, LOC004: 25 },
  },
  {
    id: 10,
    name: 'Omeprazole 20mg',
    brandName: 'Losec',
    price: 10.50,
    pbsPrice: 6.80,
    category: 'Digestive',
    inStock: true,
    stockLevel: 55,
    prescription: true,
    description: 'Proton pump inhibitor used to reduce stomach acid production',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Low risk',
    dosage: '1 capsule daily before breakfast',
    sideEffects: 'Headache, nausea, abdominal pain',
    interactions: 'May interact with clopidogrel and certain antifungals',
    image: 'https://placehold.co/100x100/d1fae5/10b981?text=Ome',
    rating: 4.5,
    reviews: 198,
    mrp: {
      preferredSupplier: 'SIG',
      avgWeeklyDemand: 12,
      minStock: 8,
      maxStock: 35,
      safetyStock: 5,
      reorderPoint: 10,
      leadTimeDays: 1,
      movementCategory: 'PBS Medium Mover',
      lastOrdered: '2026-02-11',
      lastReceived: '2026-02-12',
    },
    stockByLocation: { LOC001: 55, LOC002: 30, LOC003: 25, LOC004: 18 },
  },
  {
    id: 11,
    name: 'Amlodipine 5mg',
    brandName: 'Norvasc',
    price: 7.99,
    pbsPrice: 6.80,
    category: 'Blood Pressure',
    inStock: true,
    stockLevel: 40,
    prescription: true,
    description: 'Calcium channel blocker for treating high blood pressure and angina',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Medium risk',
    dosage: '1 tablet daily',
    sideEffects: 'Swelling of ankles, dizziness, flushing',
    interactions: 'May interact with simvastatin and grapefruit',
    image: 'https://placehold.co/100x100/e0f2fe/3b82f6?text=Aml',
    rating: 4.3,
    reviews: 112,
    mrp: {
      preferredSupplier: 'SYM',
      avgWeeklyDemand: 10,
      minStock: 7,
      maxStock: 30,
      safetyStock: 5,
      reorderPoint: 10,
      leadTimeDays: 1,
      movementCategory: 'PBS Medium Mover',
      lastOrdered: '2026-02-09',
      lastReceived: '2026-02-10',
    },
    stockByLocation: { LOC001: 40, LOC002: 22, LOC003: 18, LOC004: 12 },
  },
  {
    id: 12,
    name: 'Fluoxetine 20mg',
    brandName: 'Prozac',
    price: 8.75,
    pbsPrice: 6.80,
    category: 'Mental Health',
    inStock: true,
    stockLevel: 28,
    prescription: true,
    description: 'SSRI antidepressant used to treat depression, OCD, and panic disorder',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Medium risk',
    dosage: '1 capsule daily in the morning',
    sideEffects: 'Nausea, headache, insomnia, anxiety',
    interactions: 'Do not take with MAOIs; caution with blood thinners',
    image: 'https://placehold.co/100x100/ddd6fe/8b5cf6?text=Flu',
    rating: 4.1,
    reviews: 145,
    mrp: {
      preferredSupplier: 'SIG',
      avgWeeklyDemand: 8,
      minStock: 6,
      maxStock: 25,
      safetyStock: 4,
      reorderPoint: 8,
      leadTimeDays: 1,
      movementCategory: 'PBS Medium Mover',
      lastOrdered: '2026-02-10',
      lastReceived: '2026-02-11',
    },
    stockByLocation: { LOC001: 28, LOC002: 15, LOC003: 12, LOC004: 8 },
  },
  {
    id: 13,
    name: 'Naproxen 250mg',
    brandName: 'Naprosyn',
    price: 9.25,
    pbsPrice: 6.80,
    category: 'Pain Relief',
    inStock: true,
    stockLevel: 65,
    prescription: true,
    description: 'NSAID for treating pain, inflammation, and stiffness from arthritis',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Medium risk',
    dosage: '1 tablet twice daily with food',
    sideEffects: 'Stomach pain, heartburn, drowsiness',
    interactions: 'May interact with blood thinners and lithium',
    image: 'https://placehold.co/100x100/fee2e2/ef4444?text=Nap',
    rating: 4.3,
    reviews: 134,
    mrp: {
      preferredSupplier: 'API',
      avgWeeklyDemand: 10,
      minStock: 8,
      maxStock: 40,
      safetyStock: 5,
      reorderPoint: 10,
      leadTimeDays: 1,
      movementCategory: 'PBS Medium Mover',
      lastOrdered: '2026-02-12',
      lastReceived: '2026-02-13',
    },
    stockByLocation: { LOC001: 65, LOC002: 30, LOC003: 25, LOC004: 15 },
  },
  {
    id: 14,
    name: 'Metoprolol 50mg',
    brandName: 'Betaloc',
    price: 9.50,
    pbsPrice: 6.80,
    category: 'Blood Pressure',
    inStock: true,
    stockLevel: 35,
    prescription: true,
    description: 'Beta-blocker for high blood pressure, chest pain, and heart failure',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Medium risk',
    dosage: '1 tablet twice daily',
    sideEffects: 'Fatigue, dizziness, cold hands and feet',
    interactions: 'May interact with calcium channel blockers and insulin',
    image: 'https://placehold.co/100x100/e0f2fe/3b82f6?text=Met',
    rating: 4.2,
    reviews: 89,
    mrp: {
      preferredSupplier: 'SYM',
      avgWeeklyDemand: 10,
      minStock: 7,
      maxStock: 30,
      safetyStock: 4,
      reorderPoint: 9,
      leadTimeDays: 1,
      movementCategory: 'PBS Medium Mover',
      lastOrdered: '2026-02-11',
      lastReceived: '2026-02-12',
    },
    stockByLocation: { LOC001: 35, LOC002: 20, LOC003: 18, LOC004: 10 },
  },
  {
    id: 15,
    name: 'Insulin Glargine',
    brandName: 'Lantus',
    price: 42.50,
    pbsPrice: 6.80,
    category: 'Diabetes',
    inStock: true,
    stockLevel: 15,
    prescription: true,
    description: 'Long-acting insulin for blood sugar control in type 1 and type 2 diabetes',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'High risk',
    dosage: 'Once daily injection at the same time each day',
    sideEffects: 'Hypoglycemia, injection site reactions, weight gain',
    interactions: 'Many drug interactions; consult pharmacist',
    image: 'https://placehold.co/100x100/fef3c7/f59e0b?text=Ins',
    rating: 4.6,
    reviews: 201,
    mrp: {
      preferredSupplier: 'SIG',
      avgWeeklyDemand: 6,
      minStock: 4,
      maxStock: 18,
      safetyStock: 3,
      reorderPoint: 5,
      leadTimeDays: 1,
      movementCategory: 'Fridge Line',
      storageTemp: '2-8°C',
      lastOrdered: '2026-02-13',
      lastReceived: '2026-02-14',
    },
    stockByLocation: { LOC001: 15, LOC002: 8, LOC003: 10, LOC004: 4 },
  },
  {
    id: 16,
    name: 'Rosuvastatin 10mg',
    brandName: 'Crestor',
    price: 13.25,
    pbsPrice: 6.80,
    category: 'Cholesterol',
    inStock: true,
    stockLevel: 42,
    prescription: true,
    description: 'Statin medication for lowering cholesterol and preventing cardiovascular disease',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Medium risk',
    dosage: '1 tablet daily',
    sideEffects: 'Muscle pain, headache, nausea',
    interactions: 'May interact with certain HIV medications and blood thinners',
    image: 'https://placehold.co/100x100/e0f2fe/3b82f6?text=Ros',
    rating: 4.5,
    reviews: 178,
    mrp: {
      preferredSupplier: 'SYM',
      avgWeeklyDemand: 18,
      minStock: 12,
      maxStock: 50,
      safetyStock: 8,
      reorderPoint: 15,
      leadTimeDays: 1,
      movementCategory: 'PBS Fast Mover',
      lastOrdered: '2026-02-12',
      lastReceived: '2026-02-13',
    },
    stockByLocation: { LOC001: 42, LOC002: 25, LOC003: 20, LOC004: 12 },
  },
  {
    id: 17,
    name: 'Loratadine 10mg',
    brandName: 'Claratyne',
    price: 12.99,
    pbsPrice: null,
    category: 'Allergies',
    inStock: true,
    stockLevel: 90,
    prescription: false,
    description: 'Non-drowsy antihistamine for allergy relief including hay fever',
    tgaApproved: true,
    pbs: false,
    safetyLevel: 'Low risk',
    dosage: '1 tablet daily',
    sideEffects: 'Headache, drowsiness (rare), dry mouth',
    interactions: 'Minimal interactions; safe with most medications',
    image: 'https://placehold.co/100x100/ddd6fe/8b5cf6?text=Lor',
    rating: 4.7,
    reviews: 312,
    mrp: {
      preferredSupplier: 'API',
      avgWeeklyDemand: 20,
      minStock: 15,
      maxStock: 100,
      safetyStock: 10,
      reorderPoint: 20,
      leadTimeDays: 1,
      movementCategory: 'OTC Fast Mover',
      lastOrdered: '2026-02-14',
      lastReceived: '2026-02-15',
    },
    stockByLocation: { LOC001: 90, LOC002: 55, LOC003: 65, LOC004: 30 },
  },
  {
    id: 18,
    name: 'Doxycycline 100mg',
    brandName: 'Doryx',
    price: 14.99,
    pbsPrice: 6.80,
    category: 'Antibiotics',
    inStock: true,
    stockLevel: 30,
    prescription: true,
    description: 'Tetracycline antibiotic for treating bacterial infections and acne',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Low risk',
    dosage: '1 capsule daily with food',
    sideEffects: 'Sun sensitivity, nausea, esophageal irritation',
    interactions: 'Do not take with antacids, calcium, or iron supplements',
    image: 'https://placehold.co/100x100/fef3c7/f59e0b?text=Dox',
    rating: 4.3,
    reviews: 156,
    mrp: {
      preferredSupplier: 'CH2',
      avgWeeklyDemand: 8,
      minStock: 5,
      maxStock: 25,
      safetyStock: 3,
      reorderPoint: 7,
      leadTimeDays: 1,
      movementCategory: 'PBS Medium Mover',
      lastOrdered: '2026-02-10',
      lastReceived: '2026-02-11',
    },
    stockByLocation: { LOC001: 30, LOC002: 15, LOC003: 20, LOC004: 8 },
  },
  {
    id: 19,
    name: 'Pantoprazole 40mg',
    brandName: 'Somac',
    price: 11.75,
    pbsPrice: 6.80,
    category: 'Digestive',
    inStock: true,
    stockLevel: 48,
    prescription: true,
    description: 'Proton pump inhibitor for treating gastric ulcers and GERD',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Low risk',
    dosage: '1 tablet daily before breakfast',
    sideEffects: 'Headache, diarrhea, abdominal pain',
    interactions: 'May reduce absorption of certain medications',
    image: 'https://placehold.co/100x100/d1fae5/10b981?text=Pan',
    rating: 4.4,
    reviews: 167,
    mrp: {
      preferredSupplier: 'SYM',
      avgWeeklyDemand: 20,
      minStock: 14,
      maxStock: 50,
      safetyStock: 9,
      reorderPoint: 16,
      leadTimeDays: 1,
      movementCategory: 'PBS Fast Mover',
      lastOrdered: '2026-02-13',
      lastReceived: '2026-02-14',
    },
    stockByLocation: { LOC001: 48, LOC002: 25, LOC003: 30, LOC004: 15 },
  },
  {
    id: 20,
    name: 'Symbicort Turbuhaler',
    brandName: 'Budesonide/Formoterol',
    price: 38.99,
    pbsPrice: 6.80,
    category: 'Respiratory',
    inStock: true,
    stockLevel: 18,
    prescription: true,
    description: 'Combination inhaler for asthma and COPD maintenance therapy',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Medium risk',
    dosage: '1-2 puffs twice daily',
    sideEffects: 'Oral thrush, hoarseness, headache',
    interactions: 'May interact with beta-blockers and certain antifungals',
    image: 'https://placehold.co/100x100/e0f2fe/3b82f6?text=Sym',
    rating: 4.7,
    reviews: 234,
    mrp: {
      preferredSupplier: 'SIG',
      avgWeeklyDemand: 8,
      minStock: 5,
      maxStock: 20,
      safetyStock: 3,
      reorderPoint: 6,
      leadTimeDays: 1,
      movementCategory: 'PBS Medium Mover',
      lastOrdered: '2026-02-12',
      lastReceived: '2026-02-13',
    },
    stockByLocation: { LOC001: 18, LOC002: 10, LOC003: 12, LOC004: 5 },
  },
  {
    id: 21,
    name: 'Codeine Phosphate 30mg',
    brandName: 'Various',
    price: 16.50,
    pbsPrice: 6.80,
    category: 'Pain Relief',
    inStock: true,
    stockLevel: 20,
    prescription: true,
    description: 'Opioid analgesic for moderate to severe pain relief',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'High risk',
    dosage: '1 tablet every 4-6 hours as needed',
    sideEffects: 'Drowsiness, constipation, nausea',
    interactions: 'Do not combine with alcohol or other CNS depressants',
    image: 'https://placehold.co/100x100/fee2e2/ef4444?text=Cod',
    rating: 4.0,
    reviews: 78,
    mrp: {
      preferredSupplier: 'SYM',
      avgWeeklyDemand: 5,
      minStock: 3,
      maxStock: 15,
      safetyStock: 2,
      reorderPoint: 5,
      leadTimeDays: 1,
      movementCategory: 'S8 Controlled',
      lastOrdered: '2026-02-11',
      lastReceived: '2026-02-12',
    },
    stockByLocation: { LOC001: 20, LOC002: 8, LOC003: 12, LOC004: 5 },
  },
  {
    id: 22,
    name: 'Fexofenadine 180mg',
    brandName: 'Telfast',
    price: 15.99,
    pbsPrice: null,
    category: 'Allergies',
    inStock: true,
    stockLevel: 55,
    prescription: false,
    description: 'Non-drowsy antihistamine for seasonal allergies and chronic hives',
    tgaApproved: true,
    pbs: false,
    safetyLevel: 'Low risk',
    dosage: '1 tablet daily',
    sideEffects: 'Headache, back pain, drowsiness (rare)',
    interactions: 'Avoid taking with fruit juices (reduces absorption)',
    image: 'https://placehold.co/100x100/ddd6fe/8b5cf6?text=Fex',
    rating: 4.6,
    reviews: 289,
    mrp: {
      preferredSupplier: 'API',
      avgWeeklyDemand: 15,
      minStock: 10,
      maxStock: 60,
      safetyStock: 7,
      reorderPoint: 12,
      leadTimeDays: 1,
      movementCategory: 'OTC Medium Mover',
      lastOrdered: '2026-02-13',
      lastReceived: '2026-02-14',
    },
    stockByLocation: { LOC001: 55, LOC002: 35, LOC003: 40, LOC004: 18 },
  },
  {
    id: 23,
    name: 'Gliclazide 80mg',
    brandName: 'Diamicron',
    price: 10.25,
    pbsPrice: 6.80,
    category: 'Diabetes',
    inStock: true,
    stockLevel: 38,
    prescription: true,
    description: 'Sulfonylurea for type 2 diabetes to stimulate insulin release',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Medium risk',
    dosage: '1 tablet daily with breakfast',
    sideEffects: 'Hypoglycemia, weight gain, nausea',
    interactions: 'May interact with certain antifungals and blood thinners',
    image: 'https://placehold.co/100x100/fef3c7/f59e0b?text=Gli',
    rating: 4.3,
    reviews: 124,
    mrp: {
      preferredSupplier: 'SYM',
      avgWeeklyDemand: 10,
      minStock: 7,
      maxStock: 30,
      safetyStock: 4,
      reorderPoint: 9,
      leadTimeDays: 1,
      movementCategory: 'PBS Medium Mover',
      lastOrdered: '2026-02-12',
      lastReceived: '2026-02-13',
    },
    stockByLocation: { LOC001: 38, LOC002: 20, LOC003: 15, LOC004: 10 },
  },
  {
    id: 24,
    name: 'Escitalopram 10mg',
    brandName: 'Lexapro',
    price: 9.50,
    pbsPrice: 6.80,
    category: 'Mental Health',
    inStock: true,
    stockLevel: 45,
    prescription: true,
    description: 'SSRI antidepressant for treating depression and generalized anxiety disorder',
    tgaApproved: true,
    pbs: true,
    safetyLevel: 'Medium risk',
    dosage: '1 tablet daily',
    sideEffects: 'Nausea, insomnia, fatigue, sexual dysfunction',
    interactions: 'Do not take with MAOIs; caution with NSAIDs',
    image: 'https://placehold.co/100x100/ddd6fe/8b5cf6?text=Esc',
    rating: 4.4,
    reviews: 203,
    mrp: {
      preferredSupplier: 'SYM',
      avgWeeklyDemand: 14,
      minStock: 10,
      maxStock: 40,
      safetyStock: 6,
      reorderPoint: 12,
      leadTimeDays: 1,
      movementCategory: 'PBS Fast Mover',
      lastOrdered: '2026-02-11',
      lastReceived: '2026-02-12',
    },
    stockByLocation: { LOC001: 45, LOC002: 25, LOC003: 20, LOC004: 12 },
  }
];
